<ng-container *ngIf="settings">
  <div *ngIf="mode==='dropdown'&&!settings.customSettings.customDefaultPlaceCategory.useDefault">
    <ig-nested-menu *ngIf="!isLoading" #customDefaultPlaceBtn [title]="title"
                    [items]="isOnlyShowNodeFromUrl&&node?[node]:settings.customSettings.customDefaultPlaceCategory.customCategories"
                    (onClick)="onSelectCustomDefaultPlaceCategory($event)"
                    (onIconClick)="onSelectCustomDefaultPlaceCategory(null)"></ig-nested-menu>
  </div>

  <ig-accordion #accordion
                *ngIf="mode==='expand'||(mode==='dropdown'&&settings.customSettings.customDefaultPlaceCategory.useDefault)"
                (onIconClicked)="filterPlace('All')" [title]="title||'CATEGORIES'" id="place-filter-category"
                [mode]="mode">

    <ng-container expand dropdown>
      <button type="button" mat-menu-item (click)="onSelectCustomDefaultPlaceCategory(null)">ALL</button>
    </ng-container>

    <ng-container *ngIf="settings.customSettings.customDefaultPlaceCategory.useDefault" dropdown>
      <ng-container *ngIf="settings.dataSource?.businessType==='normal'" dropdown>
        <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.accommodation" (click)="filterPlace('Accommodations')"
             [class.is-selected]="isSelected('Accommodations')">
          Accommodations
        </button>

        <ng-container *ngIf="settings.dataSource?.place==='google'&&settings.toggle?.placeCategory.thingsToDo">
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.dining" (click)="filterPlace('Dining & Nightlife')"
               [class.is-selected]="isSelected('Dining & Nightlife')">
            Dining & Nightlife
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.shopping"
               (click)="filterPlace('Shopping')" [class.is-selected]="isSelected('Shopping')">
            Shopping
          </button>

          <button type="button" mat-menu-item *ngIf="isShowThingsToDo" (click)="filterPlace('things-to-do')"
               [class.is-selected]="isSelected('things-to-do')">Things to Do
          </button>
        </ng-container>
        <ng-container *ngIf="(settings.dataSource.place==='facebook')||!settings.toggle.placeCategory.thingsToDo">
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.activity" (click)="filterPlace('Activities')"
               [class.is-selected]="isSelected('Activities')">
            Activities
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.art" (click)="filterPlace('Arts & Culture')"
               [class.is-selected]="isSelected('Arts & Culture')">
            Arts & Culture
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.dining" (click)="filterPlace('Dining & Nightlife')"
               [class.is-selected]="isSelected('Dining & Nightlife')">
            Dining & Nightlife
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.entertainment" (click)="filterPlace('Entertainment')"
               [class.is-selected]="isSelected('Entertainment')">
            Entertainment
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.outdoor" (click)="filterPlace('Outdoors')"
               [class.is-selected]="isSelected('Outdoors & Fitness')">
            Outdoors
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.wellness" (click)="filterPlace('Wellness')"
               [class.is-selected]="isSelected('Wellness')">
            Wellness
          </button>
          <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.shopping" (click)="filterPlace('Shopping')"
               [class.is-selected]="isSelected('Shopping')">
            Shopping
          </button>
        </ng-container>

        <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.travel" (click)="filterPlace('Transportation')"
             [class.is-selected]="isSelected('Transportation')">
          Travel
        </button>
        <button type="button" mat-menu-item *ngIf="settings.toggle.placeCategory.other" (click)="filterPlace('Other')"
             [class.is-selected]="isSelected('Other')">
          Other
        </button>
      </ng-container>

      <ng-container *ngIf="settings?.dataSource?.businessType==='area business'">
        <button type="button" mat-menu-item (click)="filterPlace('Beauty')" [class.is-selected]="isSelected('Beauty')">
          Beauty
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Cars & Motor Services')"
             [class.is-selected]="isSelected('Cars & Motor Services')">
          Cars & Motor Services
        </button>

        <button type="button" mat-menu-item (click)="filterPlace('Cleaning Services')"
             [class.is-selected]="isSelected('Cleaning Services')">
          Cleaning Services
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Pet Services')"
             [class.is-selected]="isSelected('Pet Services')">
          Pet Services
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Convenience & Pharmacies')"
             [class.is-selected]="isSelected('Convenience & Pharmacies')">Convenience & Pharmacies
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Hospitals')"
             [class.is-selected]="isSelected('Hospitals')">Hospitals
        </button>
      </ng-container>

      <ng-container *ngIf="settings?.dataSource?.businessType==='local secrets'">
        <button type="button" mat-menu-item (click)="filterPlace('Art and Culture')"
             [class.is-selected]="isSelected('Art and Culture')">Arts & Culture
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Food and Drink')"
             [class.is-selected]="isSelected('Food and Drink')">
          Food & Drink
        </button>

        <button type="button" mat-menu-item (click)="filterPlace('Nightlife')"
             [class.is-selected]="isSelected('Nightlife')">
          Nightlife
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Trip & Tours Planner')"
             [class.is-selected]="isSelected('Trip & Tours Planner')">Trip & Tours Planner
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Local Rental Services')"
             [class.is-selected]="isSelected('Local Rental Services')">Local Rental Services
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Health & Personal Care')"
             [class.is-selected]="isSelected('Health & Personal Care')">Health & Personal Care
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Accommodation')"
             [class.is-selected]="isSelected('Accommodation')">Accommodations
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Sports & Leisure')"
             [class.is-selected]="isSelected('Sports & Leisure')">Sports & Leisure
        </button>
        <button type="button" mat-menu-item (click)="filterPlace('Shoppings')"
             [class.is-selected]="isSelected('Shoppings')">
          Shopping
        </button>
      </ng-container>
    </ng-container>

    <ng-container expand
                  *ngIf="mode==='expand'&&settings.customSettings.customDefaultPlaceCategory&&!settings.customSettings.customDefaultPlaceCategory.useDefault">
      <div *ngFor="let item of settings.customSettings.customDefaultPlaceCategory.customCategories"
           class="custom-default-place-category-wrapper">
        <ig-nested-accordion-item [item]="item"
                                  (onClick)="onSelectCustomDefaultPlaceCategory($event)"></ig-nested-accordion-item>
      </div>
    </ng-container>

  </ig-accordion>
</ng-container>
